import { ModalProps } from 'antd';
import { CreateProductModalExtraProps } from 'modules/products/types';
import { useState } from 'react';

import { ContextType } from './type';

export const useProviderValue = (): ContextType => {
  const [modalProps, setModalProps] = useState<
    ModalProps & CreateProductModalExtraProps
  >();
  const [visible, setVisible] = useState(false);

  const showModal = (
    params?: CreateProductModalExtraProps & { donationId: string }
  ) => {
    params && setModalProps({ ...modalProps, ...params });
    setVisible(true);
  };

  const updateModalProps = (
    props: ModalProps & CreateProductModalExtraProps
  ) => {
    setModalProps(props);
  };

  const hideModal = () => {
    setVisible(false);
  };

  return {
    modalConfig: {
      ...modalProps,
      visible,
      hide: hideModal,
    },
    showModal,
    hideModal,
    updateModalProps,
  };
};
